import { useState } from 'react';
import styles from './ImageWithDescription.module.css';
import close from "../../image/ic_close.png"

export const ImageWithDescription = ({src, description, title = "Описание"}:{src:string, description:string, title?:string}) =>{
    const [isOpen, setIsOpen] = useState(false);

    return(
        <>
            <img
                className={styles.award_image}
                src={src}
                alt={description}
                onClick={()=>setIsOpen(true)}
            />
            {isOpen &&
            <div className={styles.back} onClick={()=>setIsOpen(false)}>
                <div className={styles.container} onClick={(event)=>event.stopPropagation()}>
                    <div className={styles.close_button} onClick={()=>setIsOpen(false)}>
                        <img src={close}/>
                    </div>
                    <img className={styles.zoomed_image} src={src} alt={description}/>
                    <div className={styles.description_container}>
                        <div className={styles.description_titile}>{title}</div>
                        <div className={styles.description_content}>{description}</div>
                    </div>
                </div>
            </div>}
        </>
    )
}